<template>
  <aside class="admin-sidebar">
    <div class="sidebar-header">
      <span class="sidebar-icon">&#x2699;</span>
      <span class="sidebar-title">管理后台</span>
    </div>
    <nav class="sidebar-nav">
      <router-link to="/admin" exact-active-class="sidebar-active">
        <i class="el-icon-data-analysis"></i> 概览
      </router-link>
      <router-link to="/admin/articles" active-class="sidebar-active">
        <i class="el-icon-document"></i> 文章管理
      </router-link>
      <router-link to="/admin/categories" active-class="sidebar-active">
        <i class="el-icon-folder"></i> 分类管理
      </router-link>
      <router-link to="/admin/tags" active-class="sidebar-active">
        <i class="el-icon-collection-tag"></i> 标签管理
      </router-link>
      <router-link to="/admin/users" active-class="sidebar-active">
        <i class="el-icon-user"></i> 用户管理
      </router-link>
      <router-link to="/admin/view-records" active-class="sidebar-active">
        <i class="el-icon-view"></i> 浏览记录
      </router-link>
      <router-link to="/admin/projects" active-class="sidebar-active">
        <i class="el-icon-files"></i> 项目管理
      </router-link>
    </nav>
    <div class="sidebar-bottom">
      <router-link to="/" class="back-to-site">
        <i class="el-icon-back"></i> 返回博客
      </router-link>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'AdminSidebar'
}
</script>

<style scoped>
.admin-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 220px;
  height: 100vh;
  background: #fff;
  border-right: 1px solid #e4e7ed;
  z-index: 1001;
  display: flex;
  flex-direction: column;
}
.sidebar-header {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #e4e7ed;
}
.sidebar-icon {
  font-size: 24px;
  margin-right: 10px;
  color: #409EFF;
}
.sidebar-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.sidebar-nav {
  flex: 1;
  padding: 10px 0;
}
.sidebar-nav a {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #606266;
  font-size: 14px;
  transition: all 0.3s;
}
.sidebar-nav a i {
  margin-right: 10px;
  font-size: 16px;
}
.sidebar-nav a:hover {
  background: #ecf5ff;
  color: #409EFF;
}
.sidebar-active {
  background: #409EFF;
  color: #fff !important;
}
.sidebar-bottom {
  padding: 15px 20px;
  border-top: 1px solid #e4e7ed;
}
.back-to-site {
  color: #909399;
  font-size: 13px;
  display: flex;
  align-items: center;
}
.back-to-site i {
  margin-right: 6px;
}
.back-to-site:hover {
  color: #409EFF;
}
@media (max-width: 768px) {
  .admin-sidebar {
    width: 100%;
    height: auto;
    position: relative;
  }
}
</style>
